// A drag from a node's add-path affordance mints a PENDING edge whose
// sourceHandle is not a real path yet: plain nodes drag the literal
// 'default-edge'; section-split nodes (screening) drag
// 'default-edge:<Section>' so the picker that opens on drop scopes itself to
// the dragged section's paths. Pending edges never serialize — validation
// flags them until a real path is chosen.
export const PENDING_EDGE_HANDLE = 'default-edge'

export const isPendingEdgeHandle = (handle?: string | null): handle is string =>
  !!handle && (handle === PENDING_EDGE_HANDLE || handle.startsWith(`${PENDING_EDGE_HANDLE}:`))

export const pendingEdgeSection = (handle?: string | null): string | null =>
  handle?.startsWith(`${PENDING_EDGE_HANDLE}:`)
    ? handle.slice(PENDING_EDGE_HANDLE.length + 1) || null
    : null
